import { render, staticRenderFns } from "./stage1.vue?vue&type=template&id=a7223e26&scoped=true"
import script from "./stage1.vue?vue&type=script&lang=js"
export * from "./stage1.vue?vue&type=script&lang=js"
import style0 from "./stage1.vue?vue&type=style&index=0&id=a7223e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7223e26",
  null
  
)

export default component.exports